// extracted by mini-css-extract-plugin
export default {"steps":"mr-z","header":"nr-z","description":"or-z"};